/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Format_On_PasteInputs */

const en_options_editor_auto_format_on_paste = /** @type {(inputs: Options_Editor_Auto_Format_On_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-Format Text on Paste`)
};

const fr_options_editor_auto_format_on_paste = /** @type {(inputs: Options_Editor_Auto_Format_On_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formater automatiquement le texte lors du collage`)
};

const de_options_editor_auto_format_on_paste = /** @type {(inputs: Options_Editor_Auto_Format_On_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text beim Einfügen automatisch formatieren`)
};

const it_options_editor_auto_format_on_paste = /** @type {(inputs: Options_Editor_Auto_Format_On_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattazione automatica del testo durante l'incollaggio`)
};

const ru_options_editor_auto_format_on_paste = /** @type {(inputs: Options_Editor_Auto_Format_On_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое форматирование текста при вставке`)
};

const es_options_editor_auto_format_on_paste = /** @type {(inputs: Options_Editor_Auto_Format_On_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato automático de texto al pegar`)
};

const zh_cn2_options_editor_auto_format_on_paste = /** @type {(inputs: Options_Editor_Auto_Format_On_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴时自动格式化文本`)
};

const ja_options_editor_auto_format_on_paste = /** @type {(inputs: Options_Editor_Auto_Format_On_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貼り付け時にテキストを自動フォーマットする`)
};

const hi_options_editor_auto_format_on_paste = /** @type {(inputs: Options_Editor_Auto_Format_On_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेस्ट करने पर टेक्स्ट को ऑटो-फॉर्मेट करें`)
};

const pt_pt2_options_editor_auto_format_on_paste = /** @type {(inputs: Options_Editor_Auto_Format_On_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação automática de texto ao colar`)
};

/**
* | output |
* | --- |
* | "Auto-Format Text on Paste" |
*
* @param {Options_Editor_Auto_Format_On_PasteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_format_on_paste = /** @type {((inputs?: Options_Editor_Auto_Format_On_PasteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Format_On_PasteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_auto_format_on_paste(inputs)
	if (locale === "de") return de_options_editor_auto_format_on_paste(inputs)
	if (locale === "it") return it_options_editor_auto_format_on_paste(inputs)
	if (locale === "ru") return ru_options_editor_auto_format_on_paste(inputs)
	if (locale === "es") return es_options_editor_auto_format_on_paste(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_auto_format_on_paste(inputs)
	if (locale === "ja") return ja_options_editor_auto_format_on_paste(inputs)
	if (locale === "hi") return hi_options_editor_auto_format_on_paste(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_auto_format_on_paste(inputs)
	return en_options_editor_auto_format_on_paste(inputs)
});